import React from "react";

const CompanyUsersCard = ({ color, data }) => {
  const { _id: id, companyName = "", msgs = 0 } = data ?? {};
  const name = companyName ? companyName : "Company Name";
  return (
    <div key={id} className="company-card" style={{ "--tone": color }}>
      <div className="company-card__head">
        <div className="company-card__avatar">{name.charAt(0)}</div>
        <div className="company-card__name" title={name}>
          {name}
        </div>
      </div>
      <dl className="company-card__metrics m-0">
        <div className="company-card__metric">
          <dt>MSGs</dt>
          <dd>{msgs}</dd>
        </div>
        <div className="company-card__metric">
          <dt>MAU</dt>
          <dd>125.54K</dd>
        </div>
        <div className="company-card__metric">
          <dt>PUSH</dt>
          <dd>4.4 M</dd>
        </div>
      </dl>
    </div>
  );
};

export default CompanyUsersCard;
